// src/data/heavyDuty.js
import pocket1 from "../assets/pocketstamp/pocketstamp1.jpg";
import pocket2 from "../assets/pocketstamp/pocketstamp2.jpg";     
import pocket3 from "../assets/pocketstamp/pocketstamp3.jpg";
import pocket4 from "../assets/pocketstamp/pocketstamp4.jpg";
import pocket5 from "../assets/pocketstamp/pocketstamp5.jfif";

const heavyDutyData = [
  {
    id: 1,
    name: "Round Pocket Stamp",
    category: "pocket",
    image: pocket1,
    size: "40x40 mm",
    description: "Compact round pocket stamp (40x40 mm) ideal for logos, initials, or circular seals with clear impressions.",
  },
  {
    id: 2,
    name: "Pocket Stamp",
    category: "pocket",
    image: pocket2,
    size: "45x15 mm",
    description: "Slim rectangular pocket stamp (45x15 mm) perfect for signatures, short addresses, or custom labels.",
  },
  {
    id: 3,
    name: "Square Pocket Stamp",
    category: "pocket",
    image: pocket3,
    size: "40x40 mm",
    description: "Square pocket stamp (40x40 mm) designed for bold text, monograms, or small company logos.",
  },
  {
    id: 4,
    name: "Rectangular Pocket Stamp",
    category: "pocket",
    image: pocket4,
    size: "35x12 mm",
    description: "Mini rectangular pocket stamp (35x12 mm) suitable for dates, codes, or short identification marks.",
  },
  {
    id: 5,
    name: "Pocket Stamp",
    category: "pocket",
    image: pocket5,
    size: "40x40mm",
    description: "Versatile pocket stamp suitable for multiple applications; perfect for personalized seals and premium stationery.",
  }
];

export default heavyDutyData;
